const SkeletonCategoryCard = () => (
  <li className="flex items-center gap-2.5 rounded-2 border border-border-semantic-card bg-surface-primary-subtle px-4 py-2">
    <div className="flex-none size-16 rounded-full bg-gray-100" />
    <div className="flex-1 h-5 bg-gray-100 rounded w-2/3" />
    <div className="flex-none size-6 bg-gray-100 rounded" />
  </li>
);

export default function SkeletonFeaturedCategories() {
  return (
    <section className="content-container py-11 desktop:py-12 animate-pulse">
      <div className="flex flex-col gap-5 mb-8">
        <div className="flex flex-col gap-3">
          <div className="h-4 w-24 bg-gray-100 rounded" />
          <div className="h-10 w-3/4 bg-gray-100 rounded" />
        </div>
        <div className="h-4 w-1/2 bg-gray-100 rounded" />
        <div className="h-10 w-40 bg-gray-100 rounded" />
      </div>
      <ul className="grid grid-cols-1 tablet:grid-cols-2 gap-2 tablet:gap-x-10 tablet:gap-y-4">
        {Array.from({ length: 6 }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton, index is stable
          <SkeletonCategoryCard key={i} />
        ))}
      </ul>
    </section>
  );
}
